module.exports = __webpack_public_path__ + "img/maple_plank_600s_list.826948ec.jpg";